module.exports = __webpack_public_path__ + "static/media/We_Learn_Banner.35200ad2.png";